module.exports = new __parcel__URL__("incidentsDark.aba376a8.svg").toString();